import { render, staticRenderFns } from "./ViewEscalation.vue?vue&type=template&id=25c8f404&"
import script from "./ViewEscalation.vue?vue&type=script&lang=ts&"
export * from "./ViewEscalation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports